// Imports
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { SEO_CONFIG } from '../../environments/seo';
import { slugs } from '../../environments/static-slugs';
import { avatarConfig } from '../../environments/auth';

@Injectable({ providedIn: 'root' })
export class ConfigService {
  public themeClass: string;
  public a19PdfHeader = '../../../assets/svg/a19-pdf-header.svg';

  constructor() {}

  // Fetch env config
  getEnvironmentConfig() {
    return environment;
  }

  getSeoConfig() {
    return SEO_CONFIG;
  }

  getThemeClass(domain) {
    let cucu;
    environment.newspapers.forEach((item, index) => {
      if (item.domain === domain) {
        cucu = item.class;
      }
    });

    return cucu;
  }

  getNewspaperName(domain) {
    let cucu;
    environment.newspapers.forEach((item, index) => {
      if (item.domain === domain) {
        cucu = item.name;
      }
    });

    return cucu;
  }

  getLocale() {
    return environment.locale;
  }

  getMainNewspapers() {
    return environment.main_newspapers;
  }

  getAggregatorUrl() {
    return environment.newspapers.find(
      (newspaper) => newspaper.class === 'playbacpresse'
    ).domain;
  }

  getAllNewspapers() {
    if (environment.env === 'testing') {
      return environment.all_newspapers;
    }
    if (environment.env === 'prod') {
      return environment.all_newspapers_prod;
    }
    if (environment.env === 'preprod') {
      return environment.all_newspapers_preprod;
    }
  }

  getApiDomainByEnv() {
    const env = environment.env;
    return environment.environments[env].domain;
  }

  getStaticSlugs(subName: string) {
    return slugs[subName];
  }

  getDefaultAvatar() {
    return avatarConfig;
  }
}
